export type FieldKind =
  | 'email'
  | 'phone'
  | 'address'
  | 'company'
  | 'jobTitle'
  | 'name'
  | 'url'
  | 'headline'
  | 'department'
  | 'accreditation'
  | 'layout';

const FIELD_TITLES: Record<FieldKind, string> = {
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
  company: 'Company',
  jobTitle: 'Job title',
  name: 'Name',
  url: 'Link',
  headline: 'Headline',
  department: 'Department',
  accreditation: 'Accreditations',
  layout: 'Change layout',
};

export function getFieldTitle(kind: FieldKind | undefined): string {
  if (kind && FIELD_TITLES[kind]) {
    return FIELD_TITLES[kind];
  }
  return 'Edit';
}
